<pa-loader *ngIf="loading"></pa-loader>
<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" [width]="771" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <form class="form-style" [formGroup]="cardAddForm" (ngSubmit)="addCard()" autocomplete="off">
        <div class="rectangle">
          <div class="col-lg-5 col-md-5 col-12 px-0 d-flex card-div">
            <div class="col-12 px-0 d-flex flex-column">
              <label
                class="title">{{this.textService.keyValueMapping('addCardHeader', 'Kart Bilgilerinizi Girin', sdkInitTexts)}}</label>
              <img class="card-image"
                   src="/assets/images/card/{{ cardLogo ? cardLogo.toLowerCase(): 'defaultcard' }}.png" alt="logo"/>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 px-0 d-flex">
            <div class="path"></div>
          </div>
          <div class="col-12 col-md-5 col-lg-5 px-0 input-group-style">
            <div class="col-12 px-0 d-flex input-div">
              <mat-form-field class="input-style">
                <mat-label>{{this.textService.keyValueMapping('addCardNumberLabel', 'Kart numarasını girin', sdkInitTexts)}}</mat-label>
                <input type="tel" mask="0000 0000 0000 0000" matInput maxlength="20" formControlName="cardNumber"
                       tbOnlyNumber (keyup)="onCardChange($event)">
                <mat-error
                  *ngIf="cardAddForm.controls.cardNumber.errors && cardAddForm.controls.cardNumber.errors.ccNumber">
                  {{this.textService.keyValueMapping('msgAddCardNumberRule', 'Yanlış veya Eksik Kart Numarası Girdiniz.', sdkInitTexts)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div">
              <mat-form-field class="input-style">
                <mat-label>{{this.textService.keyValueMapping('addCardDateLabel', 'Son kullanma tarihini girin', sdkInitTexts)}}</mat-label>
                <input type="tel" matInput formControlName="expirationDate" maxlength="7" ccExp>
                <mat-error
                  *ngIf="cardAddForm.controls.expirationDate.errors && cardAddForm.controls.expirationDate.errors.expDate">
                  {{this.textService.keyValueMapping('msgAddCardSktRule', 'Son Kullanma Tarihi Hatalı veya Yanlış.', sdkInitTexts)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div" *ngIf="showCvv">
              <mat-form-field class="input-style">
                <mat-label>{{this.textService.keyValueMapping('addCardCvvLabel', 'Kartın arka yüzündeki CVV kodunu girin', sdkInitTexts)}}</mat-label>
                <input type="tel" matInput maxlength="3" formControlName="cvv" tbOnlyNumber>
                <mat-error
                  *ngIf="cardAddForm.controls.cvv.errors && cardAddForm.controls.cvv.errors.required">
                  {{this.textService.keyValueMapping('msgAddCardCvv', 'Lütfen Kartınızın Arka Tarafında Yazan Cvv\'yi Giriniz.\n', sdkInitTexts)}}
                </mat-error>
                <mat-error
                  *ngIf="cardAddForm.controls.cvv.errors && cardAddForm.controls.cvv.errors.minlength">
                  {{this.textService.keyValueMapping('msgAddCardCvvRule', 'Cvv 3 karakter olmalıdır.', sdkInitTexts)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div">
              <mat-form-field class="input-style">
                <mat-label>{{this.textService.keyValueMapping('addCardAliasLabel', 'Kart kayıt adını girin', sdkInitTexts)}}</mat-label>
                <input type="text" matInput maxlength="50" formControlName="cardName"
                       appInputRestriction="noSpecialChars">
                <mat-error
                  *ngIf="cardAddForm.controls.cardName.errors && cardAddForm.controls.cardName.errors.required">
                  {{this.textService.keyValueMapping('msgAddCardAlias', 'Lütfen Kart Üstündeki İsminizi Yazınız.', sdkInitTexts)}}
                </mat-error>
                <mat-error
                  *ngIf="cardAddForm.controls.cardName.errors && cardAddForm.controls.cardName.errors.minlength">
                  {{this.textService.keyValueMapping('msgAddCardAliasRule', 'Kart Üstündeki İsim 3 karakterden az olamaz.', sdkInitTexts)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex checkbox-div">
              <mat-checkbox class="checkbox-style" formControlName="isEngagementAccepted"><label
                [ngClass]="submitted && cardAddForm.controls.isEngagementAccepted.errors && cardAddForm.controls.isEngagementAccepted.errors.required ?
                'checkbox-description-error':'checkbox-description'">Lütfen <a><span class="text-style"
                                                                                     (click)="createAccountEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart1', 'Çerçeve Ödeme Hizmetleri Sözleşmesi', sdkInitTexts)}}</span></a>
                {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart2', '\'ni ve', sdkInitTexts)}}
                <a><span
                  class="text-style"
                  (click)="createCardEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart3', 'Kart Saklama Sözleşmesi', sdkInitTexts)}}</span></a>
                {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart4', '\'ni kabul ediyorum.', sdkInitTexts)}}
              </label>
              </mat-checkbox>
            </div>
            <div class="col-12 px-0 d-flex input-div">
              <div class="button-width">
                <button [ngClass]="(cardAddForm.valid) ? 'button-style':'button-style-passive'"
                        [disabled]="cardAddForm.invalid"><span
                  class="text-style">{{this.textService.keyValueMapping('addCardSaveButton', 'Kaydet', sdkInitTexts)}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
